
require('./every-file-has-extension');
require('./every-file-has-allowed-extensions');
require('./every-file-max-size');
require('./total-file-max-size');
require('./file-max-size');
require('./file-upload-fulfilled');
require('./file-has-allowed-extensions');
require('./files-array-length');